import React, { useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import assetsManager from "../assets/assetsmanager/assestsmanager";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import EditQuestionsModal from "../component/EditQuestionsModal";
import { updatePromptPriority } from "../hooks/updatePromptPriority";
import { AppContext } from "../context/context";
import { getPromptQuestions } from "../hooks/getPrompts";
import { deletePromptQuestion } from "../hooks/deletePromptQuestion";
import ConfirmDeleteModal from "../component/ConfirmDeleteModal";

const Questions = () => {
  const { state, dispatch } = useContext(AppContext);
  const [modalOpen, setModalOpen] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [questions, setQuestions] = useState([]);
  let source = state.activeTab === "ABCD App" ? "abcd_app" : "service_app";
  let source2 = state.activeTab === "ABCD App" ? "abcd" : "service";

  const fetchPromptQuestions = async () => {
    try {
      setLoading(true);
      const data = await getPromptQuestions();
      const fetchedQuestions = data.docs || [];
      dispatch({
        type: "SETPROMPTSLIST",
        payload: fetchedQuestions
      });
    } catch (error) {
      console.error("Failed to fetch prompt questions:", error);
      toast.error("Failed to fetch questions. Please try again.");
    }
  };

  const savePriority = async (updatedQuestions) => {
    setIsSaving(true);
    try {
      const payload = {
        source: source,
        ids: updatedQuestions.map((question) => question.id)
      };
      await updatePromptPriority(payload);
      toast.success("Priority updated successfully!");
      return true;
    } catch (error) {
      console.error("Error updating priority:", error);
      toast.error("Something went wrong");
      throw new Error(error);
    } finally {
      setIsSaving(false);
    }
  };

  const handleModalOpen = (item, index) => {
    if (item) {
      setSelectedIndex(index);
      setSelectedItem(item);
    }
  };

  const handleModalClose = () => {
    setSelectedItem(null);
    setSelectedIndex(null);
    setModalOpen(null);
  };

  const handleDeleteQuestion = async (item, questionIndex) => {
    try {
      let payload = {
        source: source,
        id: item.id
      };
      await deletePromptQuestion(payload);
      const newQuestions = questions.filter((item, index) =>
        index === questionIndex ? false : true
      );
      setQuestions(newQuestions);
      handleModalClose();
      await fetchPromptQuestions();
    } catch (error) {
      console.log("Error:", error);
    }
  };

  const handleDragEnd = async (result) => {
    const { source, destination } = result;
    if (!destination) return;
    const reorderedQuestions = Array.from(questions);
    const [movedItem] = reorderedQuestions.splice(source.index, 1);
    reorderedQuestions.splice(destination.index, 0, movedItem);
    try {
      setQuestions(reorderedQuestions);
      await savePriority(reorderedQuestions);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    console.log(questions, "qwertyutrewertytre323rty");
    setQuestions(state.promptsList[source2] || []);
  }, [state.promptsList, source]);

  useEffect(() => {
    fetchPromptQuestions();
  }, []);

  return (
    <div className="h-[calc(100%_-_56px)] pb-2 mt-2">
      <div className="flex items-center justify-between">
        <p className="text-lg font-medium text-[#424242]">
          Recommended Questions
        </p>
      </div>
      <div className="h-[calc(100%_-_32px)]">
        <div className="h-[calc(100%_-_180px)] overflow-auto">
          <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="questions">
              {(provided) => (
                <div
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  className="flex flex-col gap-3 h-[calc(100%_-_32px)] pt-6"
                >
                  {questions?.map((item, index) => (
                    <Draggable
                      key={item.id}
                      draggableId={item.id}
                      index={index}
                    >
                      {(provided) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          className="flex gap-2"
                        >
                          <div className="flex items-center">
                            <img
                              className="h-[24px]"
                              src={assetsManager?.dotBurger}
                              alt=""
                            />
                          </div>

                          <div className="border border-[#E4E4E4] rounded-lg w-full flex justify-between px-3 py-3 active:border-[#FFC7C9] active:bg-[#FFFAFA]">
                            <div className="flex gap-4">
                              <div>
                                <img
                                  className="h-[40px]"
                                  src={item.image_url}
                                  alt=""
                                />
                              </div>
                              <div className="flex flex-col">
                                <p className="text-sm text-[#5C5C5C] font-normal">
                                  Questions {index + 1}
                                </p>
                                <p className="text-[18px] text-[#313131] font-medium">
                                  {item.text}
                                </p>
                              </div>
                            </div>
                            <div className="flex gap-4 items-center">
                              <div>
                                <img
                                  onClick={() => {
                                    setModalOpen("edit");
                                    handleModalOpen(item, index);
                                  }}
                                  className="h-[18px] cursor-pointer"
                                  src={assetsManager?.edit}
                                  alt=""
                                />
                              </div>
                              <div>
                                <img
                                  onClick={() => {
                                    setModalOpen("delete");
                                    handleModalOpen(item, index);
                                  }}
                                  className="h-[18px] cursor-pointer"
                                  src={assetsManager?.deleteIcon}
                                  alt=""
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </div>
        <div className="flex gap-2 mt-5">
          <div className="flex items-center invisible">
            <img className="h-[24px]" src={assetsManager?.dotBurger} alt="" />
          </div>

          <div
            onClick={() => {
              setModalOpen("add");
              handleModalOpen(null, null);
            }}
            className="border border-dashed bg-[--primary] border-white rounded-lg w-full flex  px-3 py-3 justify-center items-center gap-2 cursor-pointer"
          >
            <img
              className="h-[16px]"
              src={assetsManager?.plusIconBlack}
              alt=""
            />
            <p className="text-base font-medium text-white">Add Question</p>
          </div>
        </div>
      </div>
      {(modalOpen === "add" || modalOpen === "edit") && (
        <EditQuestionsModal
          modalOpen={modalOpen}
          selectedItem={selectedItem}
          handleModalClose={handleModalClose}
          setSelectedItem={setSelectedItem}
          fetchPromptQuestions={fetchPromptQuestions}
        />
      )}
      {modalOpen === "delete" && (
        <ConfirmDeleteModal
          handleModalClose={handleModalClose}
          handleDelete={() => handleDeleteQuestion(selectedItem, selectedIndex)}
        />
      )}
    </div>
  );
};

export default Questions;
